import React from 'react';
import { ClickToCopy } from '@monavate/ui-core';

export const createSummaryObject = (account: any) => {
    return [
        {
            name: '',
            rows: [
                {
                    name: 'IBAN',
                    value: account?.iban && (
                        <ClickToCopy dataTestId="value-account-iban">{account.iban}</ClickToCopy>
                    ),
                },
                {
                    name: 'Sort code',
                    customComponentValue: account?.sortCode && (
                        <ClickToCopy dataTestId="value-account-sort-code">
                            {account.sortCode}
                        </ClickToCopy>
                    ),
                },
                {
                    name: 'BIC',
                    customComponentValue: account?.bankBIC && (
                        <ClickToCopy dataTestId="value-account-bic">{account.bankBIC}</ClickToCopy>
                    ),
                },
                {
                    name: 'Account number',
                    value: account?.accountNumber && (
                        <ClickToCopy dataTestId="value-account-number">
                            {account.accountNumber}
                        </ClickToCopy>
                    ),
                },
                {
                    name: 'Country',
                    value: account?.address?.country ? (
                        <ClickToCopy dataTestId="value-account-country">
                            {account?.address?.country}
                        </ClickToCopy>
                    ) : (
                        ''
                    ),
                },
                {
                    name: 'Address line 1',
                    value: account?.address?.line1 && (
                        <ClickToCopy dataTestId="value-account-address-line1">
                            {account?.address?.line1}
                        </ClickToCopy>
                    ),
                },
                {
                    name: 'Town / City',
                    value: account?.address?.line2 && (
                        <ClickToCopy dataTestId="value-account-address-line2">
                            {account?.address?.line2}
                        </ClickToCopy>
                    ),
                },
                {
                    name: 'Owner name',
                    value: account?.ownerName && (
                        <ClickToCopy dataTestId="value-account-owner-name">
                            {account.ownerName}
                        </ClickToCopy>
                    ),
                },
            ],
        },
    ];
};
